import { useCallback } from 'react';
import { usePostMessage } from '../../context/messageContext';
import { useVisualFieldData } from '../reducers';

export const usePatientResponse = () => {
  const postMessage = usePostMessage();
  const { batchMultipleUpdates } = useVisualFieldData();

  const markDotSeen = useCallback(
    ({ activeDot, missedOnceDots }) => {
      if (activeDot['repeat']) return postMessage({ type: 'useVisualFieldReducer', action: 'destroyActiveDot' });
      if (activeDot['blindspot']) {
        return batchMultipleUpdates({ handleBlindSpot: true, decreaseTestConfidence: true, destroyActiveDot: true });
      }

      const indexOfAlreadyMissedDot = missedOnceDots.findIndex((dot) => {
        return dot?.id === activeDot?.id;
      });

      const dotWasAlreadyMissed = indexOfAlreadyMissedDot !== -1;

      if (dotWasAlreadyMissed) {
        postMessage({ type: 'useVisualFieldReducer', action: 'removeFromMissedOnceArray', payload: indexOfAlreadyMissedDot });
      }
      return batchMultipleUpdates({ addSeenDot: activeDot, removeDotFromDisplay: activeDot, destroyActiveDot: true });
    },
    [postMessage, batchMultipleUpdates],
  );

  const markDotMissed = useCallback(
    ({ missedOnceDots, seenDots, activeDot }) => {
      if (activeDot['blindspot']) return batchMultipleUpdates({ handleBlindSpot: true, destroyActiveDot: true });

      const indexOfAlreadyMissedDot = missedOnceDots?.findIndex((dot) => {
        return dot?.id === activeDot?.id;
      });

      const indexOfAlreadySeenDot = seenDots?.findIndex((dot) => {
        return dot?.id === activeDot?.id;
      });

      const dotWasMissedOnce = indexOfAlreadyMissedDot !== -1;
      const dotWasAlreadySeen = indexOfAlreadySeenDot !== -1;

      if (dotWasAlreadySeen) {
        return batchMultipleUpdates({ decreaseTestConfidence: true, destroyActiveDot: true });
      } else if (dotWasMissedOnce) {
        batchMultipleUpdates({
          removeFromMissedOnceArray: indexOfAlreadyMissedDot,
          addNotSeenDot: activeDot,
          removeDotFromDisplay: activeDot,
          destroyActiveDot: true,
        });
      }
      //there is potential that the same dot will be repeated next time, as it has not been removed from display.
      else batchMultipleUpdates({ addMissedOnceDot: activeDot, destroyActiveDot: true });
    },
    [batchMultipleUpdates],
  );

  return { markDotSeen, markDotMissed };
};
